import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form } from 'redux-form';

import { handleAddressChange } from 'checkout/checkout/common/helpers';
import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { FormError } from 'common/components/layout';
import { getDefaultCountryCode } from 'common/helpers/miscHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { updateClubSignup } from 'redux/clubSignup/actions';
import { listCustomerAddresses } from 'redux/customerAddresses/actions';

import AddressPicker from './components/AddressPicker';
import { validateAddressForLoggedInCustomer } from './validators';

class Billing extends Component {
  componentDidMount() {
    const { props } = this;
    props.listCustomerAddresses();
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form, this.props);
    const clubSignup = {
      billTo: data,
      clubId: props.club.id
    };
    props.updateClubSignup(clubSignup);
  };

  handleAddressChange = (e) => {
    const { props } = this;
    const addressId = e.target.value;
    let address;
    if (addressId) {
      address = props.customerAddresses.data[addressId];
    }
    handleAddressChange(addressId, address, props.change, props.settings);
  };

  handleBack = (e) => {
    e.preventDefault();
    const { props } = this;
    props.onEdit('customer');
  };

  render() {
    const { clubSignup, handleSubmit, change, form } = this.props;
    const { customerAddresses, settings } = this.props;
    let object = { countryCode: getDefaultCountryCode(settings) };
    if (clubSignup.shipTo) {
      object = clubSignup.shipTo;
    }
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <h3>Billing address</h3>

        <AddressPicker
          customerAddresses={customerAddresses.data}
          onAddressChange={this.handleAddressChange}
        />
        <AddressForm
          object={object}
          changeFunction={change}
          settings={settings}
        />

        <div className="c7-checkout__content__buttons">
          <button type="submit" className="c7-button">
            Continue to payment information
          </button>
          <a onClick={this.handleBack}>Return to shipping method</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  const address = transformAddressData(values);
  address.customerAddressId = values.customerAddressId;
  return address;
};

const validate = (values, props) => {
  let errors = {};
  const address = transformData(values);
  address.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  address.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  address.birthYear =
    values.birthYear && convertStringToInteger(values.birthYear);
  errors = Object.assign(
    errors,
    validateAddressForLoggedInCustomer(address, props.settings)
  );
  return errors;
};

const mapStateToProps = (state) => {
  let initialValues;
  if (state.clubSignup && state.clubSignup.data) {
    const { billTo } = state.clubSignup.data;
    initialValues = initialFormValues(billTo);
  }
  return {
    customer: state.customer,
    settings: state.setting,
    customerAddresses: state.customerAddress,
    customerCreditCards: state.customerCreditCard,
    initialValues
  };
};

Billing = reduxForm({
  form: 'billinLoggedInPickup',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Billing);

export default withRouter(
  connect(mapStateToProps, {
    updateClubSignup,
    listCustomerAddresses
  })(Billing)
);
